import Modal, {
    MODAL_SIZE_EXTRA_LARGE,
} from "../Modal/Modal";
import styles from "./ExperienceHistory.module.scss";
import React, {useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import { hasValue} from "../../helpers/helperFunctions";
import moment from "moment";

const ExperienceHistory = (props) => {
    const {
        showXPHistoryModal,
        setShowXPHistoryModal,
        selectedData
    } = props;

    const dispatch = useDispatch();

    const history = selectedData?.history;


    const renderXPHistory = useMemo(() => {
        if (!history || history.length === 0) return (
            <div className={styles.noHistoryFound}>
                <span>No XP History Found</span>
            </div>
        );

        return history
            .filter(h => hasValue(h.label))
            .sort((a, b) => b.timestamp - a.timestamp)
            .map(h => {
                const renderLabel = () => {
                    if (h.labelArray) {
                        return h.labelArray.map(label => {
                            const className = /[0-9]/.test(label) ? styles.xpHistoryRowItemLabelBold : styles.xpHistoryRowItemLabel;
                            return <span className={className} key={label}>{label}</span>
                        })
                    }

                    return h.label;
                }

                const xp = Math.round(Number(h.xp) * 10) / 10;

                return (
                    <div key={h.timestamp} className={styles.xpHistoryRow}>
                        <div className={styles.xpHistoryRowItemLabelRender}>{renderLabel()}</div>
                        <div className={styles.xpHistoryRowItem}>{moment.unix(h.timestamp).format('YYYY-MM-DD , h:mm A')}</div>
                        <div className={styles.xpHistoryRowItem}>
                            <div className={styles.xpBox}>{'+' + xp + ' XP'}</div>
                        </div>
                    </div>
                )
        })
    }, [history]);

    return (
        <Modal
            show={showXPHistoryModal}
            setShow={setShowXPHistoryModal}
            type={MODAL_SIZE_EXTRA_LARGE}
            centered
            header="XP History"
        >
            <div className={styles.xpHistoryContainer}>
                <div className={styles.xpHistoryHeader}>
                    <div className={styles.xpHistoryHeaderItem}>Description</div>
                    <div className={styles.xpHistoryHeaderItem}>Date</div>
                    <div className={styles.xpHistoryHeaderItem}>XP</div>
                </div>
                {renderXPHistory}
            </div>

        </Modal>
    );
}

export default ExperienceHistory;
